export default ["choosing", "color", "stars", "show", "conclusion"];
